<div class="empty-state">
    <div class="glyph" aria-hidden="true">
        <span class="material-symbols-outlined">{{ icon }}</span>
    </div>
    <h3>{{ title }}</h3>
    <p *ngIf="message">{{ message }}</p>
    <ng-content></ng-content>
</div>
